import { FC, useEffect, useState, useRef } from 'react'
import styles from './CreatePlatform.module.css'
import s from '../../styles/common/Form.module.css'
import close from '../../assets/icons/close.svg'
import CustomInput from '../UI/CustomInput/CustomInput'
import CustomButton from '../UI/CustomButton/CustomButton'
import { Formik, FormikValues } from 'formik'
import * as yup from 'yup'
import CustomTextArea from '../UI/CustomTextArea/CustomTextArea'
import UploadPhotoComponent from '../UploadPhotoComponent/UploadPhotoComponent'
import { placesPerPage } from '../../constants/constants'

import UploadFileComponent from '../UploadFileComponent/UploadFileComponent'
import exit from '../../assets/icons/trash.svg'
import { UploadImagesType } from '../../types'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { createPlace, getPlaces, getPlacesFromCompany } from '../../redux/actions/placesAction'
import Loader from '../UI/Loader/Loader'
import { useToast } from '../../context/ToastContext'
import { getCompanies } from '../../redux/actions/companiesAction'
import Select from 'react-select'
import { useMediaQuery } from 'react-responsive'

import {
  getEstablishmentFromCompany,
  getEstablishments,
} from '../../redux/actions/establishmentsAction'
import { getMe } from '../../redux/actions/meAction'

export type CreatePlatformPropsType = {
  innCompany?: string
  onClickHandler: () => void
}

const CreatePlatform: FC<CreatePlatformPropsType> = ({ onClickHandler, innCompany }) => {
  const [activePallete, setActivePallete] = useState<boolean>(false)
  const [selectedEstablishment, setSelectedEstablishment] = useState<string>('')
  const [selectKey, setSelectKey] = useState<number>(0)
  const [photos, setPhotos] = useState<UploadImagesType[]>([])
  const [photosFile, setPhotosFile] = useState<any>([])
  const [files, setFiles] = useState<any>([])

  const [commentFile, setCommentFile] = useState<any>([])
  const { establishment } = useAppSelector((state) => state.establishments)
  const [selectedCompanyId, setSelectedCompanyId] = useState<number | undefined>(undefined)
  const { companies } = useAppSelector((state) => state.companies)
  const { meData } = useAppSelector((state) => state.me)
  const resetFormRef = useRef<(() => void) | null>(null)

  useEffect(() => {
    if (meData?.company?.id) {
      setSelectedCompanyId(meData?.company?.id)
    }
  }, [meData])

  const { user, userRole, token } = useAppSelector((state) => state.auth)

  useEffect(() => {
    dispatch(getCompanies({ itemsPerPage: 100, page: 1, token }))
  }, [])

  const [loaded, setLoaded] = useState<boolean>(false)

  const validationSchema = yup.object().shape({
    platformName: yup.string().required('Поле является обязательным'),
    city: yup.string().required('Поле является обязательным'),
    address: yup.string().required('Поле является обязательным'),
    capacity: yup
      .string()
      .required('Поле является обязательным')
      .matches(/^\d+$/, 'Поле должно содержать только числа'),
  })

  const dispatch = useAppDispatch()

  const { showSuccess, showError } = useToast()

  useEffect(() => {
    dispatch(getMe({ token }))
  }, [dispatch, token])

  const onActivePallete = () => {
    setActivePallete(!activePallete)
  }

  useEffect(() => {
    if (
      userRole === 'directorPlace' ||
      userRole === 'employeePlace' ||
      userRole === 'directorAgent'
    ) {
      dispatch(
        getEstablishmentFromCompany({
          token,
          page: 1,
          itemsPerPage: 1000,
        }),
      )
    } else {
      dispatch(getEstablishments({ token, page: 1, itemsPerPage: 1000 }))
    }
  }, [])

  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  const establishmentOptions = [
    { value: 'Все', label: 'Все' },
    ...establishment.establishments.map((e) => ({
      value: e?.id,
      label: e?.name,
    })),
  ]

  const handleClose = () => {
    setPhotos([])
    setPhotosFile([])
    setFiles([])
    setSelectedEstablishment('')
    setCommentFile([])
    setSelectKey((prev) => prev + 1)

    if (meData?.company?.id) {
      setSelectedCompanyId(meData.company.id)
    } else {
      setSelectedCompanyId(undefined)
    }

    if (resetFormRef.current) {
      resetFormRef.current()
    }

    onClickHandler()
  }

  const handleSubmitHandler = async (values: FormikValues) => {
    const name = values.platformName
    const city = values.city
    const address = values.address
    const size = values.capacity
    const description = values.description

    const formData = new FormData()

    if (photosFile.length > 10 || files.length > 10) {
      showError('Вы можете загрузить максимум 10 файлов или картинок')

      return
    }

    if (values.platformName.length === 0) {
      showError('Введите существующий ИНН Вашей компании')

      return
    }

    if (photosFile) {
      for (let i = 0; i < photosFile.length; i++) {
        formData.append('images', photosFile[i])
      }
    }
    if (files) {
      for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i])
      }
    }
    formData.append('establishment', String(selectedEstablishment))
    formData.append('companyId', String(selectedCompanyId))
    formData.append('name', name)
    formData.append('city', city)
    formData.append('address', address)
    formData.append('size', size)
    formData.append('description', description)

    setLoaded(true)
    const resultAction = await dispatch(createPlace({ formData, token }))

    if (createPlace.rejected.match(resultAction)) {
      showError('Ошибка при создании зала')
      setLoaded(false)
    } else {
      showSuccess('Зал успешно создан')
      setLoaded(false)
      handleClose()
      if (userRole === 'directorPlace' || userRole === 'employeePlace') {
        dispatch(
          getPlacesFromCompany({
            token,
            page: 1,
            itemsPerPage: placesPerPage,
            companyId: String(user.employee?.company?.id),
          }),
        )
      } else {
        dispatch(getPlaces({ token, page: 1, itemsPerPage: placesPerPage }))
      }
    }
  }

  if (loaded) {
    return <Loader />
  }

  return (
    <div className={styles.registrationModalOverlay}>
      <div className={styles.registrationModal}>
        <div className={styles.titleBlock}>
          <h1 className={styles.title}>Создание зала</h1>
          <img onClick={handleClose} className={styles.close} src={close} alt='close' />
        </div>
        <div className={styles.form}>
          <Formik
            initialValues={{
              images: [],
              platformName: '',
              city: '',
              address: '',
              capacity: '',
              description: '',
              files: [],
            }}
            validateOnBlur
            onSubmit={(values) => handleSubmitHandler(values)}
            validationSchema={validationSchema}
          >
            {(props) => {
              const {
                values,
                touched,
                setFieldValue,
                errors,
                isValid,
                handleChange,
                handleBlur,
                handleSubmit,
                resetForm,
              } = props

              resetFormRef.current = resetForm

              useEffect(() => {
                return () => {
                  resetForm()
                }
              }, [])

              const handleDeleteImage = (e: any) => {
                const targetIndex = e.target.dataset.imgindex * 1
                setPhotos([...photos.slice(0, targetIndex), ...photos.slice(targetIndex + 1)])
                setPhotosFile([
                  ...photosFile.slice(0, targetIndex),
                  ...photosFile.slice(targetIndex + 1),
                ])
                setFieldValue('images', [
                  ...values.images.slice(0, targetIndex),
                  ...values.images.slice(targetIndex + 1),
                ])
              }

              return (
                <div className={styles.formContainer}>
                  <div className={styles.inputGroup}>
                    <div className={styles.inputContainer}>
                      <div className={styles.imageUpload}>
                        <UploadPhotoComponent
                          widthOneImageContainer={146}
                          widthOneGapOfImageContainer={18}
                          setFieldValue={setFieldValue}
                          photos={photos}
                          photosFile={photosFile}
                          setPhotos={setPhotos}
                          setPhotosFiles={setPhotosFile}
                        >
                          {photos.length > 0 &&
                            photos.map((photo: any, index: any) => {
                              return (
                                <div
                                  className={styles.imagesContainer}
                                  key={index}
                                  data-imgindex={index}
                                >
                                  <div className={styles.imageExitContainer}>
                                    <img
                                      className={styles.imageExit}
                                      src={exit}
                                      alt='exit'
                                      onClick={handleDeleteImage}
                                      data-imgindex={index}
                                    />
                                  </div>
                                  <img className={styles.image} src={photo.src} alt={photo.name} />
                                </div>
                              )
                            })}
                        </UploadPhotoComponent>
                      </div>
                    </div>

                    {/* <div className={styles.inputContainer}>
                      <h4 className={styles.subtitle}>ИНН</h4>
                      {innCompany ? (
                        <div className={styles.companyBlock}>{inn}</div>
                      ) : (
                        <CustomInput
                          type='text'
                          placeholder='Введите'
                          required
                          onChange={(e) => setInn(e.target.value)}
                          value={inn}
                          className={styles.input}
                        />
                      )}
                    </div> */}
                    {!meData.company.id && (
                      <div className={styles.inputContainer}>
                        <h4 className={styles.subtitle}>Компания</h4>
                        <div className={styles.inputContainerWithError}>
                          <Select
                            className={styles.selectInput}
                            value={
                              selectedCompanyId
                                ? {
                                    value: selectedCompanyId,
                                    label:
                                      companies.companies.find((c) => c.id === selectedCompanyId)
                                        ?.name || '',
                                  }
                                : undefined
                            }
                            onChange={(selectedOption) => {
                              if (selectedOption?.value) {
                                setSelectedCompanyId(Number(selectedOption?.value))
                              }
                            }}
                            options={[
                              ...companies.companies.map((company) => ({
                                value: company.id,
                                label: company.name,
                              })),
                            ]}
                            placeholder='Выберите компанию'
                            classNamePrefix='custom-select'
                            menuPlacement='bottom'
                            menuPosition='absolute'
                            styles={{
                              singleValue: (provided) => ({
                                ...provided,
                                color: selectedCompanyId ? 'black' : provided.color,
                              }),
                              control: (provided) => ({
                                ...provided,
                                border: 'none',
                                boxShadow: 'none',
                                minHeight: 'auto',
                                backgroundColor: 'transparent',
                              }),
                              menu: (provided) => ({
                                ...provided,
                                right: 0,
                                overflow: 'auto',
                              }),
                              menuList: (provided) => ({
                                ...provided,
                                height: '100%',
                                maxHeight: '250px',
                                overflowY: 'auto',
                              }),
                              input: (provided) => ({
                                ...provided,
                                margin: 0,
                                height: isMobile ? 42 : 24,
                                padding: 0,
                              }),
                              valueContainer: (provided) => ({
                                ...provided,
                                padding: 0,
                              }),
                              dropdownIndicator: (provided) => ({
                                ...provided,
                                padding: 0,
                              }),
                              clearIndicator: (provided) => ({
                                ...provided,
                                padding: 0,
                              }),
                              indicatorSeparator: () => ({
                                display: 'none',
                              }),
                            }}
                          />
                          {/* <CustomInput
                          type='text'
                          placeholder='Введите'
                          name='companyName'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.companyName}
                          className={
                            errors.companyName && touched.companyName
                              ? `${s.inputError} ${styles.input}`
                              : styles.input
                          }
                        />
                        {touched.companyName && errors.companyName && (
                          <p className={s.errorValidation}>{errors.companyName}</p>
                        )} */}
                        </div>
                      </div>
                    )}

                    <div className={styles.inputContainer}>
                      <h4 className={styles.subtitle}>Площадка</h4>
                      <div className={styles.inputContainerWithError}>
                        <Select
                          key={selectKey}
                          className={styles.selectInput}
                          value={
                            selectedEstablishment
                              ? establishmentOptions.find(
                                  (option) => String(option.value) === selectedEstablishment,
                                ) || null
                              : null
                          }
                          options={establishmentOptions}
                          placeholder='Выберите площадку'
                          onChange={(selectedOption) => {
                            if (!selectedOption || selectedOption.value === 'Все') {
                              setSelectedEstablishment('')
                            } else {
                              setSelectedEstablishment(String(selectedOption.value))
                            }
                          }}
                          isClearable
                          classNamePrefix='custom-select'
                          menuPlacement='bottom'
                          menuPosition='absolute'
                          styles={{
                            singleValue: (provided) => ({
                              ...provided,
                              color: selectedEstablishment ? 'black' : provided.color,
                            }),
                            control: (provided) => ({
                              ...provided,
                              border: 'none',
                              boxShadow: 'none',
                              minHeight: 'auto',
                              backgroundColor: 'transparent',
                            }),
                            menu: (provided) => ({
                              ...provided,
                              right: 0,
                              overflow: 'auto',
                            }),
                            menuList: (provided) => ({
                              ...provided,
                              height: '100%',
                              maxHeight: '150px',
                              overflowY: 'auto',
                            }),
                            input: (provided) => ({
                              ...provided,
                              margin: 0,
                              padding: 0,
                              height: isMobile ? 42 : 24,
                            }),
                            valueContainer: (provided) => ({
                              ...provided,
                              padding: 0,
                            }),
                            dropdownIndicator: (provided) => ({
                              ...provided,
                              padding: 0,
                            }),
                            clearIndicator: (provided) => ({
                              ...provided,
                              padding: 0,
                            }),
                            indicatorSeparator: () => ({
                              display: 'none',
                            }),
                          }}
                        />
                        {/* <CustomInput
                          type='text'
                          placeholder='Введите'
                          name='companyName'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.companyName}
                          className={
                            errors.companyName && touched.companyName
                              ? `${s.inputError} ${styles.input}`
                              : styles.input
                          }
                        />
                        {touched.companyName && errors.companyName && (
                          <p className={s.errorValidation}>{errors.companyName}</p>
                        )} */}
                      </div>
                    </div>

                    <div className={styles.inputContainer}>
                      <h4 className={styles.subtitle}>Название зала</h4>
                      <div className={styles.inputContainerWithError}>
                        <CustomInput
                          type='text'
                          placeholder='Введите'
                          name='platformName'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.platformName}
                          className={
                            errors.platformName && touched.platformName
                              ? `${s.inputError} ${styles.input}`
                              : styles.input
                          }
                        />
                        {touched.platformName && errors.platformName && (
                          <p className={s.errorValidation}>{errors.platformName}</p>
                        )}
                      </div>
                    </div>
                    <div className={styles.inputContainer}>
                      <h4 className={styles.subtitle}>Город</h4>
                      <div className={styles.inputContainerWithError}>
                        <CustomInput
                          type='text'
                          placeholder='Введите'
                          name='city'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.city}
                          className={
                            errors.city && touched.city
                              ? `${s.inputError} ${styles.input}`
                              : styles.input
                          }
                        />
                        {touched.city && errors.city && (
                          <p className={s.errorValidation}>{errors.city}</p>
                        )}
                      </div>
                    </div>
                    <div className={styles.inputContainer}>
                      <h4 className={styles.subtitle}>Адрес</h4>
                      <div className={styles.inputContainerWithError}>
                        <CustomInput
                          type='text'
                          placeholder='Введите'
                          name='address'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.address}
                          className={
                            errors.address && touched.address
                              ? `${s.inputError} ${styles.input}`
                              : styles.input
                          }
                        />
                        {touched.address && errors.address && (
                          <p className={s.errorValidation}>{errors.address}</p>
                        )}
                      </div>
                    </div>
                    <div className={styles.inputContainer}>
                      <h4 className={styles.subtitle}>Вместительность</h4>
                      <div className={styles.inputContainerWithError}>
                        <CustomInput
                          placeholder='Введите'
                          name='capacity'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.capacity}
                          className={
                            errors.capacity && touched.capacity
                              ? `${s.inputError} ${styles.input}`
                              : styles.input
                          }
                        />
                        {touched.capacity && errors.capacity && (
                          <p className={s.errorValidation}>{errors.capacity}</p>
                        )}
                      </div>
                    </div>
                    <div className={styles.inputContainer}>
                      <h4 className={styles.subtitle}>Описание</h4>
                      <div className={styles.inputContainerWithError}>
                        <CustomTextArea
                          withoutFile
                          placeholder='Введите'
                          setCommentFile={setCommentFile}
                          name='description'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.description}
                        ></CustomTextArea>
                        {touched.description && errors.description && (
                          <p className={s.errorValidation}>{errors.description}</p>
                        )}
                      </div>
                    </div>
                    <div className={styles.inputContainer}>
                      <h4 className={styles.subtitle}>Файл</h4>
                      <UploadFileComponent setFiles={setFiles} filesArray={files} />
                    </div>
                  </div>
                  <div className={styles.footerContainer}>
                    <CustomButton
                      className={styles.submitBtn}
                      title='Создать'
                      onClick={(e) => {
                        e.preventDefault()
                        handleSubmit()
                      }}
                      type='button'
                      disabled={!isValid}
                    />
                  </div>
                </div>
              )
            }}
          </Formik>
        </div>
      </div>
    </div>
  )
}

export default CreatePlatform
